import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';

import './styles.css';
import { AuthContext } from '../../Auth';
import backgroundImg from '../../assets/login-background.webp';
import alwarqaLogo from '../../assets/alwarqaLogoComplete.png';
import AuthForm from './AuthForm';

const Login = () => {
	const { currentUser } = useContext(AuthContext);

	if (currentUser) {
		return <Navigate to="/" replace />;
	}

	return (
		<div className="login__page">
			<div className="login__left">
				<div className="login__left-top">
					<span className="login__product-label">Inspections</span>
				</div>
				<div className="login__left-body">
					<div className="login__content-block">
						<div className="login__headline-block">
							<h1 className="login__headline">Geo-referenced inspections, simplified.</h1>
							<p className="login__subtext">
								Access route imagery, captured paths, and inspection details in one workspace.
							</p>
						</div>
						<AuthForm />
						<p className="login__trust-line">
							Secure access powered by Alwarqa Survey Engineering.
						</p>
					</div>
				</div>
			</div>
			<div className="login__right">
				<img src={backgroundImg} alt="" className="login__bg-img" aria-hidden="true" />
				<div className="login__right-overlay" />
				<img src={alwarqaLogo} alt="Alwarqa Survey Engineering" className="login__alwarqa-logo" />
			</div>
		</div>
	);
};

export default Login;
